export function dedupeById<T extends { id: number | string }>(arr: T[]): T[] {
  const seen = new Set<string | number>();
  const out: T[] = [];
  for (const item of arr) {
    if (!seen.has(item.id)) {
      seen.add(item.id);
      out.push(item);
    }
  }
  return out;
}

export function sortTopLevelCommentsDesc<
  T extends {
    id: number | string;
    created_at?: string;
    createdAt?: string;
    _optimistic?: boolean;
  },
>(list: T[] = []): T[] {
  const getTs = (o: T) => {
    const s = o?.created_at ?? o?.createdAt ?? "";
    const n = Date.parse(s);
    return Number.isFinite(n) ? n : 0;
  };
  const arr = [...list];
  arr.sort((a, b) => {
    if (a._optimistic && !b._optimistic) return -1;
    if (!a._optimistic && b._optimistic) return 1;
    const tb = getTs(b);
    const ta = getTs(a);
    if (tb !== ta) return ta - tb;
    const ib = Number(b.id) || 0;
    const ia = Number(a.id) || 0;
    return ia - ib;
  });
  return arr;
}
